export const Permissions = {
    //region ALL
    ALL_MANAGE: 'all.manage',
    //endregion

    //region GATEWAY
    GATEWAY_ALL: 'gateway.*',
    GATEWAY_READ: 'gateway.read',
    GATEWAY_MANAGE: 'gateway.manage',
    GATEWAY_CREATE: 'gateway.create',
    GATEWAY_UPDATE: 'gateway.update',
    GATEWAY_DELETE: 'gateway.delete',
    //endregion

    //region USER
    USER_ALL: 'user.*',
    USER_MANAGE: 'user.manage',
    USER_MANAGE_ACCESS: 'user.manage-access',
    USER_CREATE: 'user.create',
    USER_UPDATE: 'user.update',
    USER_DELETE: 'user.delete',
    USER_READ: 'user.read',
    USER_OWN: 'user.own',
    USER_ADMIN_EXCEL: 'user.admin-excel',
    //endregion

    //region TICKET
    TICKET_ALL: 'ticket.*',
    TICKET_MANAGE: 'ticket.manage',
    TICKET_OPERATOR: 'ticket.operator',
    TICKET_READ: 'ticket.read',
    TICKET_CREATE: 'ticket.create',
    TICKET_UPDATE: 'ticket.update',
    TICKET_DELETE: 'ticket.delete',
    TICKET_RESPONSIBLE: 'ticket.responsible',
    TICKET_RESPONSIBLE_TECHNICAL: 'ticket.responsible-technical',
    TICKET_RESPONSIBLE_FINANCIAL: 'ticket.responsible-financial',
    TICKET_RESPONSIBLE_MANAGEMENT: 'ticket.responsible-management',
    //endregion

    //region TRANSACTION
    TRANSACTION_ALL: 'transaction.*',
    TRANSACTION_MANAGE: 'transaction.manage',
    TRANSACTION_READ: 'transaction.read',
    TRANSACTION_CREATE: 'transaction.create',
    TRANSACTION_UPDATE: 'transaction.update',
    TRANSACTION_DELETE: 'transaction.delete',
    TRANSACTION_WAGE: 'transaction.wage',
    TRANSACTION_CHANGE_STATUS: 'transaction.change-status',
    TRANSACTION_ADMIN_EXCEL: 'transaction.admin-excel',
    TRANSACTION_INQUIRY: 'transaction.inquiry',
    //endregion

    //region STORE
    STORE_ALL: 'store.*',
    STORE_MANAGE: 'store.manage',
    STORE_CREATE: 'store.create',
    STORE_UPDATE: 'store.update',
    STORE_DELETE: 'store.delete',
    //endregion

    //region PRODUCT
    PRODUCT_ALL: 'product.*',
    PRODUCT_READ: 'product.read',
    PRODUCT_MANAGE: 'product.manage',
    PRODUCT_CREATE: 'product.create',
    PRODUCT_UPDATE: 'product.update',
    PRODUCT_DELETE: 'product.delete',
    //endregion

    //region PARDAKHT_SHAKHSI
    PARDAKHT_SHAKHSI_ALL: 'pardakht-shakhsi.*',
    PARDAKHT_SHAKHSI_READ: 'pardakht-shakhsi.read',
    PARDAKHT_SHAKHSI_MANAGE: 'pardakht-shakhsi.manage',
    PARDAKHT_SHAKHSI_UPDATE: 'pardakht-shakhsi.update',
    //endregion

    //region NEWS
    NEWS_ALL: 'news.*',
    NEWS_MANAGE: 'news.manage',
    NEWS_READ: 'news.read',
    NEWS_CREATE: 'news.create',
    NEWS_UPDATE: 'news.update',
    NEWS_DELETE: 'news.delete',
    //endregion

    //region ADMIN_SETTINGS
    ADMIN_SETTINGS_ALL: 'admin_settings.*',
    ADMIN_SETTINGS_READ: 'admin_settings.read',
    ADMIN_SETTINGS_MANAGE: 'admin_settings.manage',
    ADMIN_SETTINGS_CREATE: 'admin_settings.create',
    ADMIN_SETTINGS_UPDATE: 'admin_settings.update',
    ADMIN_SETTINGS_DELETE: 'admin_settings.delete',
    //endregion

    //region MARKETING
    MARKETING_ALL: 'marketing.*',
    MARKETING_READ: 'marketing.read',
    MARKETING_MANAGE: 'marketing.manage',
    MARKETING_CREATE: 'marketing.create',
    MARKETING_UPDATE: 'marketing.update',
    MARKETING_DELETE: 'marketing.delete',
    //endregion

    //region POS
    POS_ALL: 'pos.*',
    POS_READ: 'pos.read',
    POS_MANAGE: 'pos.manage',
    POS_CREATE: 'pos.create',
    POS_UPDATE: 'pos.update',
    POS_DELETE: 'pos.delete',
    POS_REGISTER: 'pos.register',
    POS_VISITOR: 'pos.visitor',
    //endregion

    //region WALLET
    WALLET_ALL: 'wallet.*',
    WALLET_READ: 'wallet.read',
    WALLET_SETTING: 'wallet.setting',
    WALLET_CHANGE_STATUS: 'wallet.change-status',

    WALLET_SETTLEMENT: 'wallet.settlement',
    WALLET_MANAGE: 'wallet.manage',
    WALLET_WALLET_TO_WALLET: 'wallet.wallet-to-wallet',
    WALLET_CREATE: 'wallet.create',
    WALLET_CHARGE_USER_WALLET_BY_RECEIPT: 'wallet.charge-user-wallet-by-receipt',
    WALLET_SMS_NOTIFICATION: 'wallet.sms-notification',
    WALLET_TELEGRAM_NOTIFICATION: 'wallet.telegram-notification',
    WALLET_PANEL_CREATE_WALLET: 'wallet.create-wallet-in-panel',
    WALLET_SETTING_BLOCKED_AMOUNT: 'wallet.setting-blocked-amount',
    WALLET_MANUAL_CHARGE: 'wallet.manual-charge',
    WALLET_AUTO_SETTLEMENT_CREATION: 'wallet.auto-settlement-creation',
    WALLET_ENABLE_DISABLE_WALLET: 'wallet.enable-disable-wallet',
    WALLET_VIEW_SETTLEMENT_DETAILS: 'wallet.view-settlement-details',
    WALLET_GENERAL_SETTINGS: 'wallet.general-settings',
    WALLET_GENERAL_WAGE_SETTINGS: 'wallet.general-wage-settings',
    WALLET_SPECIFIC_SETTINGS: 'wallet.specific-settings',
    WALLET_SPECIFIC_WAGE_SETTINGS: 'wallet.specific-wage-settings',
    WALLET_SCHEDULED_CHARGE: 'wallet.scheduled-charge',
    WALLET_USER_ACCESS_MANAGEMENT: 'wallet.user-access-management',
    WALLET_VIEW_STATISTICS: 'wallet.view-statistics',
    WALLET_EXCEL_REQUESTS: 'wallet.excel-requests',
    WALLET_VIEW_WALLET_LIST: "wallet.view-wallet-list",
    WALLET_GET_BANK_STATEMENTS: "wallet.view-bank-statements",
    WALLET_MANAGE_BANKS: "wallet.manage-banks",
    WALLET_GET_SETTLEMENT_AND_CHARGE_LIST: "wallet.view-settlement-and-charge-list",
    WALLET_VIEW_ACCOUNT_BALANCE_RECONCILIATION_MENU: "wallet.account_balance_reconciliation_menu",
    WALLET_VIEW_GENERAL_SETTINGS: "wallet.view-general-settings",
    WALLET_VIEW_GENERAL_WAGE_SETTINGS: "wallet.view-general-wage-settings",
    WALLET_VIEW_CUSTOM_WAGE_SETTINGS:  "wallet.view-custom-wage-settings",
    WALLET_VIEW_SPECIFIC_SETTINGS: "wallet.view-specific-settings",
    WALLET_UPCOMING_SETTLEMENT_SETTINGS: "wallet.upcoming-settlement-settings",
    WALLET_SETTLEMENT_LIMIT_SETTINGS: "wallet.settlement-limit-settings",
    WALLET_INTERBANK_TRANSFER: "wallet.interbank-transfer",
    WALLET_PAYMENT_SETTLEMENT_REQUESTS: "wallet.payment-settlement-requests",
    WALLET_ENABLE_DISABLE_SETTINGS: "wallet.enable-disable-settings",
    //endregion

    //region OPEN_BANKING
    OPEN_BANKING_ALL: 'open-banking.*',
    OPEN_BANKING_READ: 'open-banking.read',
    OPEN_BANKING_MANAGE: 'open-banking.manage',
    OPEN_BANKING_CREATE: 'open-banking.create',
    OPEN_BANKING_UPDATE: 'open-banking.update',
    OPEN_BANKING_DELETE: 'open-banking.delete',
    //endregion

    //region DEPOSIT
    DEPOSIT_ALL: 'deposit.*',
    DEPOSIT_READ: 'deposit.read',
    DEPOSIT_MANAGE: 'deposit.manage',
    DEPOSIT_CREATE: 'deposit.create',
    DEPOSIT_UPDATE: 'deposit.update',
    DEPOSIT_DELETE: 'deposit.delete',
    //endregion

    //region CARD_TO_CARD
    CARD_TO_CARD_ALL: 'card-to-card.*',
    CARD_TO_CARD_READ: 'card-to-card.read',
    CARD_TO_CARD_MANAGE: 'card-to-card.manage',
    CARD_TO_CARD_CREATE: 'card-to-card.create',
    CARD_TO_CARD_UPDATE: 'card-to-card.update',
    CARD_TO_CARD_DELETE: 'card-to-card.delete',
    //endregion

    //region ONLINE_CONTRACT
    ONLINE_CONTRACT_ALL: 'online-contract.*',
    ONLINE_CONTRACT_READ: 'online-contract.read',
    ONLINE_CONTRACT_MANAGE: 'online-contract.manage',
    ONLINE_CONTRACT_CREATE: 'online-contract.create',
    ONLINE_CONTRACT_UPDATE: 'online-contract.update',
    ONLINE_CONTRACT_DELETE: 'online-contract.delete',
    //endregion

    //region MONITORING
    MONITORING_ALL: 'monitoring.*',
    MONITORING_READ: 'monitoring.read',
    MONITORING_MANAGE: 'monitoring.manage',
    MONITORING_CREATE: 'monitoring.create',
    MONITORING_UPDATE: 'monitoring.update',
    MONITORING_DELETE: 'monitoring.delete',
    //endregion

    //region ACCOUNTING
    ACCOUNTING_ALL: 'accounting.*',
    ACCOUNTING_MANAGE: 'accounting.manage',
    ACCOUNTING_READ: 'accounting.read',
    ACCOUNTING_SETTING: 'accounting.setting',
    ACCOUNTING_CREATE_TRANSACTION: 'accounting.create-transaction',
    ACCOUNTING_UPDATE_TRANSACTION: 'accounting.update-transaction',
    ACCOUNTING_DELETE_TRANSACTION: 'accounting.delete-transaction',
    ACCOUNTING_CREATE_BANK_ACCOUNT: 'accounting.create-bank-account',
    ACCOUNTING_UPDATE_BANK_ACCOUNT: 'accounting.update-bank-account',
    ACCOUNTING_DELETE_BANK_ACCOUNT: 'accounting.delete-bank-account',
    ACCOUNTING_NOTIFICATION: 'accounting.notification',
    //endregion

    //region TECH_SUPPORT
    TECH_SUPPORT_ALL: 'tech-support.*',
    TECH_SUPPORT_ACTION: 'tech-support.action',
    //endregion

    //region CHANGE_NUMBER
    CHANGE_NUMBER_ALL: 'change-number.*',
    CHANGE_NUMBER_CHANGE: 'change-number.change',
    //endregion

    //region COMMENT
    COMMENT_DELETE: 'comment.delete',
    //endregion

    SETTLEMENT_ADMIN_EXCEL: 'settlement.admin-excel',

    //region BUSINESS
    BUSINESS_BANNER_READ: 'business.read',
    BUSINESS_BANNER_UPDATE: 'business.update',
    BUSINESS_BANNER_DELETE: 'business.delete',
    //endregion

};

export const WalletOperatorPermissions = [
    Permissions.WALLET_SETTING_BLOCKED_AMOUNT,
    Permissions.WALLET_MANUAL_CHARGE,
    Permissions.WALLET_AUTO_SETTLEMENT_CREATION,
    Permissions.WALLET_ENABLE_DISABLE_WALLET,
    Permissions.WALLET_VIEW_SETTLEMENT_DETAILS,
    Permissions.WALLET_VIEW_WALLET_LIST,
    Permissions.WALLET_GET_BANK_STATEMENTS,
    Permissions.WALLET_MANAGE_BANKS,
    Permissions.WALLET_GET_SETTLEMENT_AND_CHARGE_LIST,
    Permissions.WALLET_VIEW_GENERAL_SETTINGS,
    Permissions.WALLET_VIEW_CUSTOM_WAGE_SETTINGS,
    Permissions.WALLET_VIEW_SPECIFIC_SETTINGS,
    Permissions.WALLET_ENABLE_DISABLE_SETTINGS,
]

export const SupportPermissions = [
    Permissions.WALLET_MANUAL_CHARGE,
    Permissions.WALLET_AUTO_SETTLEMENT_CREATION,
    Permissions.WALLET_ENABLE_DISABLE_WALLET,
    Permissions.WALLET_GENERAL_SETTINGS,
    Permissions.WALLET_GENERAL_WAGE_SETTINGS,
    Permissions.WALLET_SPECIFIC_SETTINGS,
    Permissions.WALLET_SPECIFIC_WAGE_SETTINGS,
    Permissions.WALLET_USER_ACCESS_MANAGEMENT,
    Permissions.WALLET_SCHEDULED_CHARGE,
    Permissions.WALLET_VIEW_WALLET_LIST,
    Permissions.WALLET_GET_SETTLEMENT_AND_CHARGE_LIST,
    Permissions.WALLET_VIEW_ACCOUNT_BALANCE_RECONCILIATION_MENU,
    Permissions.WALLET_VIEW_GENERAL_SETTINGS,
    Permissions.WALLET_VIEW_CUSTOM_WAGE_SETTINGS,
    Permissions.WALLET_VIEW_SPECIFIC_SETTINGS,
    Permissions.WALLET_UPCOMING_SETTLEMENT_SETTINGS,
    Permissions.WALLET_SETTLEMENT_LIMIT_SETTINGS,
]

export const WalletPermissions = [
    Permissions.WALLET_SETTLEMENT,
    Permissions.WALLET_MANAGE,
    Permissions.WALLET_WALLET_TO_WALLET,
    Permissions.WALLET_CREATE,
    Permissions.WALLET_CHARGE_USER_WALLET_BY_RECEIPT,
    Permissions.WALLET_SMS_NOTIFICATION,
    Permissions.WALLET_TELEGRAM_NOTIFICATION,
    Permissions.WALLET_PANEL_CREATE_WALLET,
    Permissions.WALLET_SETTING_BLOCKED_AMOUNT,
    Permissions.WALLET_MANUAL_CHARGE,
    Permissions.WALLET_AUTO_SETTLEMENT_CREATION,
    Permissions.WALLET_ENABLE_DISABLE_WALLET,
    Permissions.WALLET_VIEW_SETTLEMENT_DETAILS,
    Permissions.WALLET_GENERAL_SETTINGS,
    Permissions.WALLET_GENERAL_WAGE_SETTINGS,
    Permissions.WALLET_SPECIFIC_SETTINGS,
    Permissions.WALLET_SPECIFIC_WAGE_SETTINGS,
    Permissions.WALLET_SCHEDULED_CHARGE,
    Permissions.WALLET_USER_ACCESS_MANAGEMENT,
    Permissions.WALLET_VIEW_STATISTICS,
    Permissions.WALLET_VIEW_WALLET_LIST,
    Permissions.WALLET_GET_SETTLEMENT_AND_CHARGE_LIST,
    Permissions.WALLET_VIEW_ACCOUNT_BALANCE_RECONCILIATION_MENU,
    Permissions.WALLET_VIEW_GENERAL_SETTINGS,
    Permissions.WALLET_VIEW_GENERAL_WAGE_SETTINGS,
    Permissions.WALLET_VIEW_CUSTOM_WAGE_SETTINGS,
    Permissions.WALLET_VIEW_SPECIFIC_SETTINGS,
    Permissions.WALLET_INTERBANK_TRANSFER,
    Permissions.WALLET_PAYMENT_SETTLEMENT_REQUESTS,
]

export const AccountingPermissions = [
    Permissions.ACCOUNTING_MANAGE,
    Permissions.ACCOUNTING_READ,
    Permissions.ACCOUNTING_SETTING,
    Permissions.ACCOUNTING_CREATE_TRANSACTION,
    Permissions.ACCOUNTING_UPDATE_TRANSACTION,
    Permissions.ACCOUNTING_DELETE_TRANSACTION,
    Permissions.ACCOUNTING_CREATE_BANK_ACCOUNT,
    Permissions.ACCOUNTING_UPDATE_BANK_ACCOUNT,
    Permissions.ACCOUNTING_DELETE_BANK_ACCOUNT,
    Permissions.ACCOUNTING_NOTIFICATION,
    Permissions.WALLET_EXCEL_REQUESTS,
    Permissions.WALLET_VIEW_STATISTICS,
    Permissions.WALLET_VIEW_SETTLEMENT_DETAILS,
    Permissions.WALLET_VIEW_WALLET_LIST,
    Permissions.WALLET_GET_BANK_STATEMENTS,
    Permissions.WALLET_GET_SETTLEMENT_AND_CHARGE_LIST,
    Permissions.WALLET_VIEW_ACCOUNT_BALANCE_RECONCILIATION_MENU,
    Permissions.WALLET_VIEW_GENERAL_SETTINGS,
    Permissions.WALLET_VIEW_CUSTOM_WAGE_SETTINGS,
    Permissions.WALLET_VIEW_GENERAL_WAGE_SETTINGS,
    Permissions.WALLET_VIEW_SPECIFIC_SETTINGS,
]

export const TechSupportPermissions = [
    Permissions.TECH_SUPPORT_ALL,
    Permissions.TECH_SUPPORT_ACTION,
    Permissions.WALLET_MANUAL_CHARGE,
    Permissions.WALLET_AUTO_SETTLEMENT_CREATION,
    Permissions.WALLET_USER_ACCESS_MANAGEMENT,
    Permissions.WALLET_SCHEDULED_CHARGE,
    Permissions.WALLET_VIEW_WALLET_LIST,
    Permissions.WALLET_MANAGE_BANKS,
    Permissions.WALLET_GET_SETTLEMENT_AND_CHARGE_LIST,
    Permissions.WALLET_VIEW_ACCOUNT_BALANCE_RECONCILIATION_MENU,
    Permissions.WALLET_VIEW_GENERAL_SETTINGS,
    Permissions.WALLET_VIEW_CUSTOM_WAGE_SETTINGS,
    Permissions.WALLET_VIEW_SPECIFIC_SETTINGS,
    Permissions.WALLET_ENABLE_DISABLE_SETTINGS,
]